export const GET_DAILY_REPORT_DATA = "ALL_CASES/GET_DAILY_REPORT_DATA";
export const GET_DAILY_REPORT_DATA_SUCCESS = "ALL_CASES/GET_DAILY_REPORT_DATA_SUCCESS";
export const GET_DAILY_REPORT_DATA_FAILURE = "ALL_CASES/GET_DAILY_REPORT_DATA_FAILURE";

export const GET_ALL_REPORTS_DATA = "ALL_CASES/GET_ALL_REPORTS_DATA";
export const GET_ALL_REPORTS_DATA_SUCCESS = "ALL_CASES/GET_ALL_REPORTS_DATA_SUCCESS";
export const GET_ALL_REPORTS_DATA_FAILURE = "ALL_CASES/GET_ALL_REPORTS_DATA_FAILURE";

export const UPDATE_REPORT_NOTES = "ALL_CASES/UPDATE_REPORT_NOTES";
export const UPDATE_REPORT_NOTES_SUCCESS = "ALL_CASES/UPDATE_REPORT_NOTES_SUCCESS";
export const UPDATE_REPORT_NOTES_FAILURE = "ALL_CASES/UPDATE_REPORT_NOTES_FAILURE";

export const EXPORT_DOC = "ALL_CASES/EXPORT_DOC";
export const EXPORT_DOC_SUCCESS = "ALL_CASES/EXPORT_DOC_SUCCESS";
export const EXPORT_DOC_FAILURE = "ALL_CASES/EXPORT_DOC_FAILURE";



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/DailyReport/constants.js